const AP_GLOVE_UNAVAILABLE_TITLE = 'Inte tillgängligt med valda filter';

function apGloveId(value) {
  return String(value || '').split('/').pop();
}

function apGloveBool(value) {
  return value === true || value === 'true';
}

function initArbetsPROGloveFilter() {
  const root = document.querySelector('[data-ap-glove-filter-section]');
  if (!root || root.dataset.apGloveInitialized === 'true') return;

  const sectionId = root.dataset.apGloveFilterSection;
  const dataNode = document.getElementById(`ap-glove-filter-data-${sectionId}`);
  if (!dataNode) return;

  let raw = [];
  try {
    raw = JSON.parse(dataNode.textContent || '[]');
  } catch (_) {
    return;
  }

  const products = raw.map((product) => ({
    id: apGloveId(product.id),
    sizes: [...new Set((Array.isArray(product.sizes) ? product.sizes : []).map(String))],
    features: Object.fromEntries(
      Object.entries(product.features || {}).map(([key, value]) => [key, apGloveBool(value)])
    )
  }));

  const productMap = new Map(products.map((product) => [product.id, product]));
  const sizeButtons = Array.from(root.querySelectorAll('[data-ap-glove-size]'));
  const featureInputs = Array.from(root.querySelectorAll('[data-ap-glove-feature]'));
  const resetButton = root.querySelector('[data-ap-glove-reset]');
  const countNode = root.querySelector('[data-ap-glove-result-count]');
  const filter = root.querySelector('.ap-glove-filter');
  const mobileToggle = root.querySelector('[data-ap-glove-mobile-filter-toggle]');
  const selectedSizes = new Set();

  if (filter && mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      const open = filter.classList.toggle('is-mobile-open');
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  root.dataset.apGloveInitialized = 'true';

  const currentFeatures = () =>
    featureInputs
      .filter((input) => input instanceof HTMLInputElement && input.checked)
      .map((input) => input.dataset.apGloveFeature)
      .filter(Boolean);

  const matchesFeatures = (product, features) =>
    features.every((feature) => product.features?.[feature] === true);

  const matchesProduct = (product) => {
    if (selectedSizes.size && !product.sizes.some((size) => selectedSizes.has(size))) return false;
    return matchesFeatures(product, currentFeatures());
  };

  const getCards = () =>
    Array.from(document.querySelectorAll('#MainContent li.product-grid__item[data-product-id]'))
      .map((card) => ({ card, product: productMap.get(apGloveId(card.dataset.productId)) }))
      .filter(({ product }) => Boolean(product));

  const setSizeAvailability = (button, available) => {
    if (!(button instanceof HTMLButtonElement)) return;
    const active = selectedSizes.has(String(button.dataset.apGloveSize || ''));
    const unavailable = !available && !active;

    button.disabled = unavailable;
    button.classList.toggle('is-unavailable', unavailable);
    button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    if (unavailable) button.title = AP_GLOVE_UNAVAILABLE_TITLE;
    else if (button.title === AP_GLOVE_UNAVAILABLE_TITLE) button.removeAttribute('title');
  };

  const setFeatureAvailability = (input, available) => {
    if (!(input instanceof HTMLInputElement)) return;
    const unavailable = !available && !input.checked;
    const wrapper = input.closest('.ap-glove-feature');

    input.disabled = unavailable;
    input.setAttribute('aria-disabled', unavailable ? 'true' : 'false');

    if (wrapper instanceof HTMLElement) {
      wrapper.classList.toggle('is-unavailable', unavailable);
      wrapper.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
      if (unavailable) wrapper.title = AP_GLOVE_UNAVAILABLE_TITLE;
      else if (wrapper.title === AP_GLOVE_UNAVAILABLE_TITLE) wrapper.removeAttribute('title');
    }
  };

  const updateAvailability = () => {
    const features = currentFeatures();

    sizeButtons.forEach((button) => {
      const size = String(button.dataset.apGloveSize || '');
      const available = products.some(
        (product) => product.sizes.includes(size) && matchesFeatures(product, features)
      );
      setSizeAvailability(button, available);
    });

    featureInputs.forEach((input) => {
      if (!(input instanceof HTMLInputElement)) return;
      const feature = input.dataset.apGloveFeature;
      if (!feature) return;

      const candidateFeatures = [...new Set([...features, feature])];
      const available = products.some((product) => {
        if (selectedSizes.size && !product.sizes.some((size) => selectedSizes.has(size))) return false;
        return matchesFeatures(product, candidateFeatures);
      });

      setFeatureAvailability(input, available);
    });
  };

  const updateActiveSizes = () => {
    sizeButtons.forEach((button) => {
      const size = String(button.dataset.apGloveSize || '');
      const active = selectedSizes.has(size);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  };

  const apply = () => {
    let count = 0;

    getCards().forEach(({ card, product }) => {
      const visible = matchesProduct(product);
      card.hidden = !visible;
      card.classList.toggle('ap-glove-filter-hidden', !visible);
      if (visible) count += 1;
    });

    if (countNode) {
      countNode.textContent = count === 1 ? '1 produkt matchar' : `${count} produkter matchar`;
    }

    const shopifyCount = count === 1 ? '1 artikel' : `${count} artiklar`;
    document.querySelectorAll('#MainContent .products-count-wrapper [role="status"]').forEach((node) => {
      node.textContent = shopifyCount;
    });

    updateActiveSizes();
    updateAvailability();
  };

  root.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const sizeButton = event.target.closest('[data-ap-glove-size]');
      if (sizeButton instanceof HTMLButtonElement && root.contains(sizeButton)) {
        event.preventDefault();
        if (sizeButton.disabled) return;

        const size = String(sizeButton.dataset.apGloveSize || '');
        if (selectedSizes.has(size)) selectedSizes.delete(size);
        else selectedSizes.add(size);

        apply();
        return;
      }

      const reset = event.target.closest('[data-ap-glove-reset]');
      if (reset && root.contains(reset)) {
        event.preventDefault();
        selectedSizes.clear();
        featureInputs.forEach((input) => {
          if (input instanceof HTMLInputElement) input.checked = false;
        });
        apply();
      }
    },
    true
  );

  root.addEventListener('change', (event) => {
    if (event.target instanceof Element && event.target.matches('[data-ap-glove-feature]')) {
      apply();
    }
  });

  apply();

  let timer;
  const main = document.querySelector('#MainContent');
  if (main) {
    new MutationObserver(() => {
      clearTimeout(timer);
      timer = setTimeout(apply, 80);
    }).observe(main, { childList: true, subtree: true });
  }
}

function updateArbetsPROGloveSidebarTop() {
  if (!window.matchMedia('(min-width: 990px)').matches) {
    document.documentElement.style.removeProperty('--ap-glove-sidebar-top');
    return;
  }

  let headerBottom = 0;
  const selectors = '.shopify-section-group-header-group, header-component, .header-section, [data-sticky-header], header';

  document.querySelectorAll(selectors).forEach((element) => {
    if (element.closest('#MainContent')) return;

    const rect = element.getBoundingClientRect();
    if (rect.height <= 0 || rect.bottom <= 0 || rect.top > 160) return;

    const position = window.getComputedStyle(element).position;
    const isTopLayer = position === 'sticky' || position === 'fixed' || rect.top <= 1;
    if (!isTopLayer) return;

    headerBottom = Math.max(headerBottom, Math.min(rect.bottom, 180));
  });

  document.documentElement.style.setProperty(
    '--ap-glove-sidebar-top',
    `${Math.max(8, Math.round(headerBottom + 10))}px`
  );
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initArbetsPROGloveFilter();
    updateArbetsPROGloveSidebarTop();
  }, { once: true });
} else {
  initArbetsPROGloveFilter();
  updateArbetsPROGloveSidebarTop();
}

window.addEventListener('scroll', () => requestAnimationFrame(updateArbetsPROGloveSidebarTop), { passive: true });
window.addEventListener('resize', () => requestAnimationFrame(updateArbetsPROGloveSidebarTop), { passive: true });
document.addEventListener('shopify:section:load', () => {
  requestAnimationFrame(initArbetsPROGloveFilter);
  requestAnimationFrame(updateArbetsPROGloveSidebarTop);
});
